import Swal from "sweetalert2";

interface ConfirmOptions {
  title: string;
  text?: string;
  confirmText?: string;
  cancelText?: string;
  danger?: boolean;
}

const BASE = {
  background: "#ffffff",
  color: "#0f172a",
  customClass: { popup: "rounded-2xl" },
};

/** Onay diyaloğu. true = onaylandı. */
export async function confirmDialog({
  title,
  text,
  confirmText = "Onayla",
  cancelText = "Vazgeç",
  danger = false,
}: ConfirmOptions): Promise<boolean> {
  const result = await Swal.fire({
    ...BASE,
    title,
    text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    reverseButtons: true,
    confirmButtonColor: danger ? "#e11d48" : "#4f46e5",
    cancelButtonColor: "#64748b",
  });
  return result.isConfirmed;
}

/** Gerekçe isteyen onay diyaloğu. null = iptal, string = (boş olabilir) gerekçe. */
export async function promptReasonDialog(options: {
  title: string;
  label?: string;
  placeholder?: string;
  confirmText?: string;
  minLength?: number;
  danger?: boolean;
}): Promise<string | null> {
  const { title, label, placeholder, confirmText = "Onayla", minLength = 0, danger = false } = options;
  const result = await Swal.fire({
    ...BASE,
    title,
    input: "text",
    inputLabel: label,
    inputPlaceholder: placeholder,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: "Vazgeç",
    reverseButtons: true,
    confirmButtonColor: danger ? "#e11d48" : "#4f46e5",
    cancelButtonColor: "#64748b",
    inputValidator: (value) => {
      if (minLength > 0 && (!value || value.trim().length < minLength)) {
        return `En az ${minLength} karakter girmelisiniz.`;
      }
      return null;
    },
  });
  if (!result.isConfirmed) {
    return null;
  }
  return typeof result.value === "string" ? result.value : "";
}

/** Bilgi/uyarı/başarı modalı (alert yerine). */
export async function notifyDialog(
  message: string,
  tone: "success" | "error" | "info" = "info",
  title?: string,
): Promise<void> {
  await Swal.fire({
    ...BASE,
    title: title ?? (tone === "error" ? "Hata" : tone === "success" ? "Başarılı" : "Bilgi"),
    text: message,
    icon: tone === "info" ? "info" : tone,
    confirmButtonText: "Tamam",
    confirmButtonColor: "#4f46e5",
  });
}
